import Footer from "components/navigation/Footer";
import Navbar from "components/navigation/Navbar";
import Layout from "hocs/layouts/Layout";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { get_categories } from "redux/actions/categories/categories";
import { connect } from "react-redux";
import {
	get_blog_list,
	get_blog_list_page,
	search_blog,
	search_blog_page,
} from "redux/actions/blog/blog";
import CategoriesHeader from "components/blog/CategoriesHeader";
import { useParams } from "react-router-dom";
import BlogList from "components/blog/search/BlogList";

function Search({
	get_categories,
	categories,
	posts,
	count,
	next,
	previous,
	search_blog,
	search_blog_page,
}) {
	const params = useParams();
	const term = params.term;
	console.log(term);
	useEffect(() => {
		window.scrollTo(0, 0);
		search_blog(term);
		get_categories();
	}, []);

	return (
		<Layout>
			<Helmet>
				<title>Fundación Arduvi | Blog</title>
				<meta
					name="description"
					content="Organización sin ánimo de lucro."
				/>
				<meta
					name="keywords"
					content="Organización sin ánimo de lucro."
				/>
				<meta name="robots" content="all" />
				<link rel="canonical" href="https://fundacionarduvi.org/" />
				<meta name="author" content="Fundación Arduvi" />
				<meta name="publisher" content="Fundación Arduvi" />

				{/* Social Media Tags */}
				<meta
					property="og:title"
					content="Fundación Arduvi | Inclusión con Amor"
				/>
				<meta
					property="og:description"
					content="Organización sin ánimo de lucro."
				/>
				<meta property="og:url" content="https://fundacionarduvi.org/" />
				<meta
					property="og:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>

				<meta
					name="twitter:title"
					content="Fundación Arduvi | Inclusión con Amor"
				/>
				<meta
					name="twitter:description"
					content="Organización sin ánimo de lucro."
				/>
				<meta
					name="twitter:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>
				<meta name="twitter:card" content="summary_large_image" />
			</Helmet>
			<header className="flex justify-center">
				<Navbar />
			</header>
			<div className="pt-24">
			<CategoriesHeader categories={categories && categories} />
				<div className="mx-auto max-w-full px-4 sm:px-6 lg:px-8">
					{/* We've used 3xl here, but feel free to try other max-widths based on your needs */}
					<div className="mx-auto max-w-full my-10">
						{/* Content goes here */}
						<BlogList
							posts={posts && posts}
							get_blog_list_page={search_blog_page}
							term={term}
							count={count && count}
						/>
					</div>
				</div>
			</div>
			<Footer />
		</Layout>
	);
}
const mapStateToProps = (state) => ({
	posts: state.blog.filtered_posts,
	count: state.blog.count,
	next: state.blog.next,
	previous: state.blog.previous,
	categories: state.categories.categories,
});

export default connect(mapStateToProps, {
	search_blog,
	search_blog_page,
	get_categories
})(Search);
